import React from 'react';
interface ProductSelectorProps {
  products: {
    id: string;
    name: string;
    thumbnail: string;
  }[];
  activeProductId: string;
  onSelectProduct: (productId: string) => void;
}
const ProductSelector: React.FC<ProductSelectorProps> = ({
  products,
  activeProductId,
  onSelectProduct
}) => {
  return <div className="h-full overflow-y-auto" data-id="element-149">
      <h3 className="text-sm font-medium text-gray-700 mb-3 px-1" data-id="element-150">
        Browse Collection
      </h3>
      <div className="flex flex-row lg:flex-col gap-3 overflow-x-auto pb-2 lg:pb-0" data-id="element-151">
        {products.map(product => <button key={product.id} onClick={() => onSelectProduct(product.id)} className={`relative flex-shrink-0 rounded-lg overflow-hidden transition-all duration-200 ${activeProductId === product.id ? 'ring-3 ring-[#752F50] shadow-md scale-105 z-10' : 'ring-1 ring-gray-200 opacity-75 hover:opacity-90'}`} data-id="element-152">
            <div className="relative w-16 h-16 lg:w-auto lg:pb-[70%]" data-id="element-153">
              <img src={product.thumbnail} alt={product.name} className={`absolute inset-0 w-full h-full object-cover ${activeProductId === product.id ? 'brightness-110 contrast-105' : ''}`} data-id="element-154" />
              {activeProductId === product.id && <div className="absolute inset-0 bg-[#752F50] bg-opacity-10 lg:bg-opacity-5" data-id="element-155"></div>}
            </div>
            <div className={`p-2 bg-white/95 hidden lg:block ${activeProductId === product.id ? 'bg-[#f9f4f7]' : ''}`} data-id="element-156">
              <span className={`text-xs font-medium line-clamp-2 ${activeProductId === product.id ? 'text-[#752F50]' : 'text-gray-800'}`} data-id="element-157">
                {product.name}
              </span>
            </div>
            {/* Mobile indicator for selected product */}
            {activeProductId === product.id && <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#752F50] lg:hidden" data-id="element-158"></div>}
          </button>)}
      </div>
    </div>;
};
export default ProductSelector;